import {config} from '../config';

export default {
    getAwsRegion: () => config.data.aws.awsRegion,
};
